import type { LoaderFunctionArgs } from '@remix-run/node'
import { Outlet, json, useMatches } from '@remix-run/react'
import { Breadcrumb, Footer, Header } from '~/design-system/components'
import { Container } from '~/design-system/primitives'
import { GlobalToastProvider } from '~/hooks/useGlobalToast'
import { getSession, sessionStorage } from '~/session'
import type { InvalidStages } from '~/type/Cart'

/**
 * Função temporária para carregar dados do carrinho
 * @returns Cart
 */
export const loader = async ({ request }: LoaderFunctionArgs) => {
  const session = await getSession(request)

  const invalidStages =
    (session.get('invalidStages') as InvalidStages[]) || ([] as unknown as InvalidStages[])

  return json(
    { invalidStages },
    {
      headers: {
        'Set-Cookie': await sessionStorage.commitSession(session),
      },
    },
  )
}

export default function Checkout() {
  const matches = useMatches() as Matches

  return (
    <>
      <Header />
      <main className="flex flex-col bg-gray-10 min-h-[480px] lg:min-h-[600px]">
        <GlobalToastProvider>
          <Container className=" py-6">
            <Breadcrumb activeRoute={matches?.[2]?.id} />
            <Outlet />
          </Container>
        </GlobalToastProvider>
      </main>
      <Footer />
    </>
  )
}
